import { useSyncExternalStore } from "react"
import { getVoximplantClient } from "@/lib/voice/voximplant-client"

// True while the agent's softphone has a call in any phase
// (ringing/connecting/active/failed-but-not-yet-dismissed).
// The softphone is single-slot, so this is the signal the
// contacts row-actions Call button uses to disable itself —
// an agent can only ever be on one call at a time.
//
// Subscribes to the Voximplant singleton via
// useSyncExternalStore so the value tracks the live SDK
// state across Inertia navigations. Cheap enough to call
// from every contact row (it's one subscription per
// component to the same module-level store).
export function useSoftphoneBusy(): boolean {
  const client = getVoximplantClient()
  return useSyncExternalStore(
    client.subscribe,
    () => client.getState().call !== null,
    () => false,
  )
}
